import Modal from "../../utils/customModal";
import NotificationForm from "./notificationForm";
import React, { useEffect, useState } from "react";
import { loadingHtml } from "../../utils/functions";
import { useDispatch, useSelector } from "react-redux";
import SecondaryButton from 'canvas-core-react/lib/SecondaryButton';
import { getNotification } from "../../../Redux/reducer/notifications";
import { getNotificationById, clearNotification } from "../../../Redux/actions/notificationsAction";

const getData = (data) => {
  if(!data) return {};
  
  if (Object.keys(data).length === 0) return {};

  let group = { name: "", countryCode: "", email: "", actions: [] };

  /* istanbul ignore else */
  if (data.name !== undefined) {
    const actions = [];

    /* istanbul ignore else */
    if( typeof data.actions == 'string' ) { data.actions = data.actions.split('|'); }
    Object.keys(data.actions).map(
      (key) => (actions[data.actions[key]] = true)
    );

    group = {
      name: data.name,
      countryCode:
        data.countryCode !== undefined ? data.countryCode : data.country.code,
      email: data.email,
      actions,
    };
  }

  return group;
};

const NotificationApprovalDetail = (props) => {
  const dispatch = useDispatch();
  const [contentReady, setContentReady] = useState(false);
  const notification = useSelector((state) => getNotification(state));

  useEffect(() => {
    dispatch(getNotificationById(props.notificationId));

    return () => { dispatch(clearNotification()) }
  }, []);

  useEffect(() => {
    setContentReady(true)
  }, [notification]);


  return (
    <div className="company-details">
      {contentReady ? (
        <div className="row col-12 pendingDetails">
          <div
            className={`${
              notification.recordTmp !== null &&
              notification.recordTmp.data !== null
                ? "col-6"
                : "col-12"
            }`}
          >
            <p className="edit-profile-style">Información actual</p>
            <NotificationForm
              group={getData(notification)}
              readOnly={true}
              approval={true}
            />
          </div>
          {notification.recordTmp !== null &&
            notification.recordTmp.data !== null && (
              <div className="col-6 gray-background">
                <p className="edit-profile-style updated-info">
                  Información actualizada
                </p>
                <NotificationForm
                  group={getData(notification.recordTmp.data)}
                  readOnly={true}
                  approval={true}
                />
              </div>
            )}
          <div className="form-actions clearfix">
            <SecondaryButton className="accept" onClick={props.closeInfo}>Atrás</SecondaryButton>
            {/* <button className="button button--pill accept" onClick={() => props.closeInfo()}>Atrás</button> */}
          </div>
        </div>
      ) : (
        // <p>Ready</p>
        <Modal show={true}>{loadingHtml()}</Modal>
      )}
    </div>
  );
};

export { getData };
export default NotificationApprovalDetail;
